<template>
  <div class="amendment-document">
    <section-title class="mt-4 mb-3" has-line title="Documento de Enmienda" />

    <document-info
      :add-file="!readOnly"
      :custom-add-file="false"
      :document="document"
      document-title="Tipo de documento:"
      :file-preview="readOnly"
      show-filename
      v-on="$listeners"
    />

    <div v-if="!readOnly">
      <section-title
        class="amendment-document__section-title d-none d-md-block"
        icon="far fa-check-circle"
        reverse
        title="Certifiación de Documento de Enmienda"
        title-class="amendment-document__section-title__info"
      />

      <validation-provider
        v-slot="{ errors }"
        name="certificaction"
        rules="required"
      >
        <custom-checkbox-single-option
          ref="customCheckboxRef"
          v-model="certified"
          class="custom-single-option amendment-document__checkbox"
          custom-error-msg="Favor certificar el documento de enmienda."
          :error="errors[0]"
          :option-text="item.question"
          :title="item.questionTitle"
        />
      </validation-provider>
    </div>
  </div>
</template>

<script>
import SectionTitle from 'SectionTitle';
import DocumentInfo from '@/views/provider/proposalHistory/components/DocumentInfo.vue';
import CustomCheckboxSingleOption from 'custom-checkbox-single-option';

export default {
  name: 'AmendmentDocument',
  components: {
    SectionTitle,
    DocumentInfo,
    CustomCheckboxSingleOption,
  },
  props: {
    amendmentDocument: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data: () => ({
    item: {
      question: `Certifico que la información es correcta y deseo continuar para someter el documento.`,
      questionTitle:
        'Certifico que el Documento de Enmienda sometido es una copia fiel y exacta del documento original.',
    },
    certified: null,
    document: {},
  }),
  computed: {
    readOnly() {
      return this.document.documentId != null;
    },
  },
  watch: {
    amendmentDocument: {
      inmediate: true,
      handler(current) {
        if (current) {
          const info = {
            ...current,
            documentTypeName: 'Documento de Enmienda',
          };
          this.document = info;
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/shared/scss/config/colors.scss';

::v-deep .amendment-document {
  &__section-title {
    margin-top: 1.5rem;
    margin-bottom: 1rem;
    .title-icon {
      font-size: 1.25rem;
      color: map-get($colors, 'orange');
    }

    .dot {
      background-color: white;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &__info {
      font-size: 1.25rem;
    }
  }

  &__checkbox {
    .title-container {
      font-weight: bold;
    }
    .checkbox-word-container {
      p {
        font-size: 1rem;
        font-weight: bold;
        @media screen and (max-width: 768px) {
          font-size: 0.8571rem;
        }
      }
    }
  }
}
.document-info {
  background-color: map-get($colors, 'secondary-3');
  margin-bottom: 2rem;
}
</style>
